/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_Last_NameInputs */

const en_tables_custom_pages_last_name = /** @type {(inputs: Tables_Custom_Pages_Last_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages Last Name`)
};

const de_tables_custom_pages_last_name = /** @type {(inputs: Tables_Custom_Pages_Last_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "Pages Last Name" |
*
* @param {Tables_Custom_Pages_Last_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_last_name = /** @type {((inputs?: Tables_Custom_Pages_Last_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_Last_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_last_name(inputs)
	return de_tables_custom_pages_last_name(inputs)
});